import { LegalFormSettings } from '@features/invoicingSettings/types/legalSettings/legalFormSettings'

export const getLegalFormSettingsDefaultValues = (): LegalFormSettings => {
  return {
    isLegalGuaranteeOfConformity: false,
    isMemberOfAccreditedAssociation: false,
    isSiretPendingAssignment: false,
    isVatOnDebitsEnabled: false,
  }
}
